import lru from 'tiny-lru';

const MAX_SIZE = 50;
const TLL = 60000;

const registry = lru(MAX_SIZE, TLL);
export default registry;
